import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import TopNav from "../components/TopNav";
import { COURSE, getSubtopic } from "../data/course";
import { Bookmark, Clock, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Bookmarks() {
  const { user, progress, toggleBookmark } = useApp();
  const nav = useNavigate();

  React.useEffect(() => {
    if (!user) nav("/");
  }, [user, nav]);

  const bookmarks = (progress?.bookmarks || [])
    .map((subId) => getSubtopic(subId))
    .filter(Boolean);

  return (
    <div className="min-h-screen bg-background paper-texture" data-testid="bookmarks-page">
      <TopNav />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
        <div className="mono text-[11px] uppercase tracking-[0.3em] text-accent mb-1">
          Your Reading List
        </div>
        <h1 className="serif text-5xl mb-6">Bookmarks</h1>

        {bookmarks.length === 0 ? (
          <div className="rounded-md border border-border bg-card p-8 text-center">
            <Bookmark className="w-10 h-10 mx-auto text-muted-foreground mb-3" />
            <p className="text-lg serif">No bookmarks yet.</p>
            <p className="text-sm text-muted-foreground mt-1">
              Click the bookmark icon on any subtopic to save it for later.
            </p>
            <Button asChild className="mt-4">
              <Link to="/home">Browse Modules</Link>
            </Button>
          </div>
        ) : (
          <ul className="grid sm:grid-cols-2 gap-4">
            {bookmarks.map(({ module: m, sub }) => (
              <li
                key={sub.id}
                className="rounded-md border border-border bg-card p-5 flex flex-col"
                data-testid={`bookmark-item-${sub.id}`}
              >
                <span className="mono text-[10px] uppercase tracking-widest text-muted-foreground">
                  Module {m.number} • {m.title}
                </span>
                <h3 className="serif text-xl mt-2">{sub.title}</h3>
                <div className="mono text-xs text-muted-foreground mt-1 inline-flex items-center gap-1">
                  <Clock className="w-3 h-3" /> {sub.readingTime}
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <button
                    className="text-xs text-destructive underline"
                    onClick={() => toggleBookmark(sub.id)}
                    data-testid={`remove-bookmark-${sub.id}`}
                  >
                    Remove
                  </button>
                  <Button
                    size="sm"
                    onClick={() => nav(`/module/${m.id}?sub=${sub.id}`)}
                    data-testid={`open-bookmark-${sub.id}`}
                  >
                    Read <ArrowRight className="w-3.5 h-3.5 ml-1" />
                  </Button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}
